import api from "../api";

export const ACTION_TYPES = {
    DOWNLOAD_OC: 'DOWNLOAD_OC'
}

export const download_oc = (lang, token, supplierId,nvpQuoteMultipleUnit,consecutive, onError, onSuccess) => dispatch => {
    api.Supplier().downloadOC(lang,token,supplierId,nvpQuoteMultipleUnit,consecutive)
    .then(response => {
        dispatch({
            type: ACTION_TYPES.DOWNLOAD_OC,
            payload: response.data
        })
        onSuccess(response.data)
    })
    .catch(err => onError(err))
}